import classNames from 'classnames';
import React from 'react';

import {Button, Dropdown, Icon, MenuListItem, Text} from '@albert-io/atomic';

import type { FilterOption} from './types';
import {FILTER_OPTION} from './types';

const FILTER_OPTIONS = Object.values(FILTER_OPTION) as FilterOption[];

export interface Props {
  selectedFilter: FilterOption;
  setSelectedFilter: (option: FilterOption) => void;
}

export function FilterDropdown({selectedFilter, setSelectedFilter}: Props) {
  'use memo';

  return (
    <Dropdown
      contentClassName='p-x1!'
      position='bottom-start'
      trayProps={{
        modifiers: {
          preventOverflow: 0
        }
      }}
      trigger={
        <Button
          className='items-center gap-x1-quarter font-normal'
          color='secondary'
          variant='outlined'
        >
          {selectedFilter}
          <Icon icon='caret-down' />
        </Button>
      }
      closeOnItemClicked
      positionFixed
    >
      {FILTER_OPTIONS.map((option) => (
        <MenuListItem
          key={option}
          as='li'
          className={classNames(
            'justify-start border-0! px-x1-half! py-x1! hover:background-info-subtle!',
            {
              'background-info-subtle!': selectedFilter === option
            }
          )}
          onClick={() => setSelectedFilter(option)}
          aria-selected={selectedFilter === option}
        >
          <Text
            className='flex w-full items-center justify-between'
            size={'m'}
            color={selectedFilter === option ? 'info' : 'primary'}
          >
            {option}
            {selectedFilter === option && <Icon icon='check' color='info' />}
          </Text>
        </MenuListItem>
      ))}
    </Dropdown>
  );
}
